import type { ChangeEventHandler } from "react";
import { Field } from "../components";

export function PasswordField({
  mode,
  revealed,
  value,
  onChange,
  onRevealChange,
}: {
  mode: "login" | "register";
  revealed: boolean;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onRevealChange: (revealed: boolean) => void;
}) {
  const canReveal = mode === "register";
  return (
    <>
      <Field label="密码" hint="至少 10 位，建议交给密码管理器保存">
        <div className="password-field-control">
          <input
            autoComplete={mode === "login" ? "current-password" : "new-password"}
            maxLength={128}
            minLength={10}
            onChange={onChange}
            placeholder="••••••••••••"
            required
            type={canReveal && revealed ? "text" : "password"}
            value={value}
          />
          {canReveal ? (
            <button
              aria-pressed={revealed}
              className="password-visibility-toggle"
              onClick={() => onRevealChange(!revealed)}
              type="button"
            >
              {revealed ? "隐藏密码" : "显示密码"}
            </button>
          ) : null}
        </div>
      </Field>
      {canReveal ? (
        <div className="security-note password-security-note" role="note">
          <strong>密码不会被明文保存</strong>
          <p>
            在正式站点中，密码通过 HTTPS/TLS 加密传输。服务器使用随机盐和
            scrypt
            慢哈希，把密码转换成不可逆的验证值；数据库只保存盐和哈希，不能解密还原原密码。
          </p>
          <p>
            登录时会对本次输入执行同样计算并比较验证结果，管理员无法查看你的原密码。慢哈希会提高离线猜测成本，但弱密码仍可能被猜中，请使用独立长密码并交给密码管理器保存。
          </p>
        </div>
      ) : null}
    </>
  );
}
